import { render } from "./GuestsPage.vue?vue&type=template&id=4d7772ee"
import script from "./GuestsPage.vue?vue&type=script&lang=js"
export * from "./GuestsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__